module.exports = __webpack_public_path__ + "static/media/6.87b734bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/6.png
// module id = 1542
// module chunks = 0